const formatCurrencyNegative = (amount: number): string => {
	const formatted = amount.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
	});

	return amount === 0 ? formatted : `(${formatted})`;
};

const formatCurrencyPositive = (amount: number): string => {
	const formatted = amount.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
	});

	return formatted;
};

export const formatCurrency = (amount: number): string => {
	if (amount >= 0) {
		return formatCurrencyPositive(amount);
	}

	return formatCurrencyNegative(amount * -1);
};
